import { Icon } from '@iconify/react/dist/iconify.js';
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { toast } from 'react-toastify';
import { deletePackageApi, getPackageSizeApi, IMG_URL } from '../../apiHelper/authService';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import { setSelectedPackage } from '../../redux/authModalSlice';

const PackageV2 = () => {

    const [activeTab, setActiveTab] = useState("ALL");
    const [currentPage, setCurrentPage] = useState(1);
    const [selectedPackageId, setSelectedPackageId] = useState(null);

    const dispatch = useDispatch()


    const [itemsPerPage] = useState(8);


    const { user } = useSelector((state) => state.authModal);
    // const [categories, setCategories] = useState();
    const [packageData, setPackageData] = useState();



    const fromCountry = user?.from;
    const toCountry = user?.to;




    // console.log("UserData:", fromCountry)

    const [loading, setLoading] = useState(false);
    // useEffect(() => {
    //     const table = $('#dataTable').DataTable({
    //         pageLength: 10,
    //     });
    //     return () => {
    //         table.destroy(true);
    //     };
    // }, []);




    const getPackageSizes = async () => {
        setLoading(true);



        // const toastId = toast.loading("Fetching Email Templates...");

        try {
            let body = { activeTab : activeTab}
            const data = await getPackageSizeApi(body);
            // setCategories(data);
            setPackageData(data)
            // toast.success("Email Templates fetched successfully!", { id: toastId });
        } catch (err) {
            console.error("Fetch Error:", err);

            // toast.error(
            //     err?.message || "Something went wrong while fetching email templates.",
            //     { id: toastId }
            // );
        } finally {
            setLoading(false);
        }
    };


    useEffect(() => {

        getPackageSizes()


    }, [activeTab])



    // console.log(packageTableData)

    const packageTableData = packageData?.packageSizes
    console.log(packageTableData)



    // const [emailData, setEmailData] = useState([
    //     {
    //         id: 1,
    //         title: "Hello",
    //         subject: "Welcome to our newsletter!",
    //         message: "Thanks for subscribing to our email updates. Stay tuned for the latest news and offers!",
    //         image: "assets/images/user-list/user-list1.png"
    //     },
    //     {
    //         id: 2,
    //         title: "Weekly Update",
    //         subject: "Here's what you missed this week",
    //         message: "Catch up on this week's most important stories, tips, and product updates all in one place.",
    //         image: "assets/images/user-list/user-list1.png"
    //     },
    //     {
    //         id: 3,
    //         title: "Special Offer!",
    //         subject: "Limited time 50% off everything!",
    //         message: "Don't miss our limited-time sale. Enjoy 50% off on all products. Shop now before it ends!",
    //         image: "assets/images/user-list/user-list1.png"
    //     },
    //     {
    //         id: 4,
    //         title: "Account Alert",
    //         subject: "We noticed a new login to your account",
    //         message: "If this was you, you can safely disregard this email. If not, please reset your password immediately.",
    //         image: "assets/images/user-list/user-list1.png"
    //     },
    //     {
    //         id: 5,
    //         title: "Event Invitation",
    //         subject: "Join us for the Annual Tech Conference",
    //         message: "We’re excited to invite you to our annual tech event. Network, learn, and grow with us. Register today!",
    //         image: "assets/images/user-list/user-list1.png"
    //     }
    // ]);


    const [searchQuery, setSearchQuery] = useState("");


    const filteredData = packageTableData?.filter((item) =>
        Object.values(item).some((val) =>
            String(val).toLowerCase().includes(searchQuery.toLowerCase())
        )
    );


    const totalItems = filteredData?.length || 0;
    const itemsPerPageSafe = itemsPerPage || 1;
    const totalPages = Math.ceil(totalItems / itemsPerPageSafe);
    const startIdx = (currentPage - 1) * itemsPerPage;
    const currentItems = filteredData?.slice(startIdx, startIdx + itemsPerPage);

    const goToPage = (page) => {
        if (page >= 1 && page <= totalPages) {
            setCurrentPage(page);
        }
    };

    const handleConfirmDelete = async () => {
        if (!selectedPackageId) return;

        setLoading(true);



        const toastId = toast.loading("Deleting...");

        try {
            const data = await deletePackageApi(selectedPackageId,);
            getPackageSizes()

            toast.success("Deleted", { id: toastId });
            const modalEl = document.getElementById('exampleModalEdit');
            const modalBackdrop = document.querySelector('.modal-backdrop');

            modalEl.classList.remove('show');
            modalEl.style.display = 'none';
            modalEl.setAttribute('aria-hidden', 'true');

            if (modalBackdrop) modalBackdrop.remove();
            document.body.classList.remove('modal-open');
            document.body.style.overflow = '';
            document.body.style.paddingRight = '';
        } catch (err) {
            console.error("Fetch Error:", err);

            toast.error(
                err?.message || "Something went wrong while fetching categories.",
                { id: toastId }
            );
        } finally {
            setLoading(false);
            // setSelectedCategoryId(null)
        }

    }

    // function stripHtml(html) {
    //     const div = document.createElement('div');
    //     div.innerHTML = html;
    //     return div.textContent || div.innerText || '';
    // }

    // const handleConfirmDelete = async () => {
    //     if (!selectedMailId) return;

    //     setLoading(true);



    //     const toastId = toast.loading("Deleting...");

    //     try {
    //         const data = await deleteEmailTemplate({ id: selectedMailId });
    //         getEmailTemplates()


    //         toast.success("Delted", { id: toastId });
    //         const modalEl = document.getElementById('exampleModalEdit');
    //         const modalBackdrop = document.querySelector('.modal-backdrop');

    //         modalEl.classList.remove('show');
    //         modalEl.style.display = 'none';
    //         modalEl.setAttribute('aria-hidden', 'true');

    //         if (modalBackdrop) modalBackdrop.remove();
    //         document.body.classList.remove('modal-open');
    //         document.body.style.overflow = '';
    //         document.body.style.paddingRight = '';
    //     } catch (err) {
    //         console.error("Fetch Error:", err);

    //         toast.error(
    //             err?.message || "Something went wrong while fetching categories.",
    //             { id: toastId }
    //         );
    //     } finally {
    //         setLoading(false);

    //     }

    // }

      const tabOptions = [
        { label: "All", value: "ALL" },
        { label: "B2B", value: "B2B" },
        { label: "B2C", value: "B2C" },
      ];

    console.log("Filtered Data", filteredData)
    return (
      <>
        <div className="card h-100 p-0 radius-12">
          <div className="card-header border-bottom bg-base py-16 px-24 d-flex align-items-center flex-wrap gap-3 justify-content-between">
            <div className="d-flex align-items-center flex-wrap gap-3">
              <form className="navbar-search">
                <input
                  type="text"
                  className="bg-base h-40-px w-auto"
                  name="search"
                  placeholder="Search"
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                />
                <Icon icon="ion:search-outline" className="icon" />
              </form>
            </div>
            <div className="d-flex" style={{ alignItems: "center" }}>
              <div className="card-body px-14">
                <ul
                  className="nav bordered-tab border border-top-0 border-start-0 border-end-0 d-inline-flex nav-pills mb-8"
                  role="tablist"
                >
                  {tabOptions.map((tab) => (
                    <li
                      className="nav-item"
                      key={tab.value}
                      role="presentation"
                    >
                      <button
                        className={`nav-link px-16 py-10 ${
                          activeTab === tab.value ? "active" : ""
                        }`}
                        type="button"
                        role="tab"
                        onClick={() => setActiveTab(tab.value)}
                      >
                        {tab.label}
                      </button>
                    </li>
                  ))}
                </ul>
              </div>
              <Link
                to={"/add-package"}
                className="btn btn-primary text-sm btn-sm px-12 py-12 radius-8 d-flex align-items-center gap-2"
              >
                <Icon
                  icon="ic:baseline-plus"
                  className="icon text-xl line-height-1"
                />
                Add New Package Sizes
              </Link>
            </div>
          </div>
          <div
            className="card-body p-24"
            style={{
              minHeight: "60vh",
              display: "flex",
              flexDirection: "column",
            }}
          >
            <div className="row gy-4" style={{ flex: "1" }}>
              {loading ? (
                <div
                  style={{
                    width: "100%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <div
                    className="spinner-border"
                    role="status"
                    style={{
                      color: "#243E85",
                      width: "2rem",
                      height: "2rem",
                      borderWidth: "0.3em",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <span className="visually-hidden">Loading...</span>
                  </div>
                </div>
              ) : currentItems?.length > 0 ? (
                currentItems?.map((pkageDta) => (
                  <div
                    className="col-xxl-3 col-md-6 col-sm-6 col-12 user-grid-card   "
                    key={pkageDta?.id}
                  >
                    <div className="position-relative border radius-16 overflow-hidden">


                      <div className='position-absolute top-0 left-0 text-primary-600 ' style={{marginLeft:"1rem", marginTop:"1rem"}}>
                        {`(${pkageDta?.packageCategory})`}

                        </div>
                      <div className="dropdown position-absolute top-0 end-0 me-16 mt-16">
                        <button
                          type="button"
                          data-bs-toggle="dropdown"
                          aria-expanded="false"
                          className="bg-white-gradient-light text-primary-600 w-32-px h-32-px radius-8 border border-primary-light-white d-flex justify-content-center align-items-center text-white"
                        >
                          <Icon
                            icon="entypo:dots-three-vertical"
                            className="icon "
                          />
                        </button>
                        <ul className="dropdown-menu p-12 border bg-base shadow">
                          <li>
                            <Link
                              onClick={() =>
                                dispatch(setSelectedPackage(pkageDta))
                              }
                              className="dropdown-item px-16 py-8 rounded text-secondary-light bg-hover-neutral-200 text-hover-neutral-900 d-flex align-items-center gap-10"
                              to={"/add-package"}
                            >
                              Edit
                            </Link>
                          </li>
                          <li>
                            <button
                              onClick={() => setSelectedPackageId(pkageDta.id)}
                              data-bs-toggle="modal"
                              data-bs-target="#exampleModalEdit"
                              type="button"
                              className="delete-btn dropdown-item px-16 py-8 rounded text-secondary-light bg-hover-danger-100 text-hover-danger-600 d-flex align-items-center gap-10"
                            >
                              Delete
                            </button>
                          </li>
                        </ul>
                      </div>
                      <div className="ps-16 pb-16 pe-16 text-center pt-16">
                        <div
                          className="border radius-16 border-width-2-px w-100-px h-100-px object-fit-cover"
                          style={{ margin: "auto" }}
                        >
                          <img
                            // src="assets/images/user-grid/package.jpg"
                            src={`${IMG_URL}/${pkageDta?.icon_url}`}
                            alt=""
                            className="p-4 w-90 h-100"
                            style={{ objectFit: "contain" }}
                          />
                        </div>

                        <h6 className="text-lg my-16  fw-semibold">
                          {" "}
                          {pkageDta.size_name}
                        </h6>

                        <div
                          className="radius-12 py-12 px-16 w-100 mb-16"
                          style={{
                            background:
                              "linear-gradient(135deg, #fdfbfb 0%, #ebedee 100%)",
                            boxShadow: "inset 0 0 6px rgba(0,0,0,0.04)",
                            border: "1px solid #e5e7eb",
                          }}
                        >
                          <div className="row text-sm fw-medium text-start">
                            <div className="col-6 mb-8 d-flex align-items-center">
                              <Icon
                                icon="mdi:ruler"
                                className="me-2 text-primary-600"
                              />
                              <span className="text-muted me-1">Length:</span>{" "}
                              {pkageDta.size_length}{" "}
                              <span className="badge bg-light text-dark ms-1">
                                {pkageDta?.inch ? "In" : "Ft"}
                              </span>
                            </div>
                            <div className="col-6 mb-8 d-flex align-items-center">
                              <Icon
                                icon="mdi:resize"
                                className="me-2 text-primary-600"
                              />
                              <span className="text-muted me-1">Width:</span>{" "}
                              {pkageDta?.size_width}{" "}
                              <span className="badge bg-light text-dark ms-1">
                                {pkageDta?.inch ? "In" : "Ft"}
                              </span>
                            </div>
                            <div className="col-6 d-flex align-items-center">
                              <Icon
                                icon="mdi:arrow-expand-vertical"
                                className="me-2 text-primary-600"
                              />
                              <span className="text-muted me-1">Height:</span>{" "}
                              {pkageDta?.size_height}{" "}
                              <span className="badge bg-light text-dark ms-1">
                                {pkageDta?.inch ? "In" : "Ft"}
                              </span>
                            </div>
                            <div className="col-6 d-flex align-items-center">
                              <Icon
                                icon="mdi:weight"
                                className="me-2 text-primary-600"
                              />
                              <span className="text-muted me-1">Weight:</span>{" "}
                              {pkageDta?.size_weight}{" "}
                              <span className="badge bg-light text-dark ms-1">
                                kg
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                ))
              ) : (
                <div
                  style={{
                    minHeight: "60vh",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <p>No Package Sizes Found</p>
                </div>
              )}
            </div>
            {/* <div className="d-flex align-items-center justify-content-between flex-wrap gap-2 mt-24">
                    <span>Showing 1 to 10 of 12 entries</span>
                    <ul className="pagination d-flex flex-wrap align-items-center gap-2 justify-content-center">
                        <li className="page-item">
                            <Link
                                className="page-link bg-neutral-200 text-secondary-light fw-semibold radius-8 border-0 d-flex align-items-center justify-content-center h-32-px  text-md"
                                to="#"
                            >
                                <Icon icon="ep:d-arrow-left" className="" />
                            </Link>
                        </li>
                        <li className="page-item">
                            <Link
                                className="page-link text-secondary-light fw-semibold radius-8 border-0 d-flex align-items-center justify-content-center h-32-px w-32-px text-md bg-primary-600 text-white"
                                to="#"
                            >
                                1
                            </Link>
                        </li>
                        <li className="page-item">
                            <Link
                                className="page-link bg-neutral-200 text-secondary-light fw-semibold radius-8 border-0 d-flex align-items-center justify-content-center h-32-px w-32-px"
                                to="#"
                            >
                                2
                            </Link>
                        </li>
                        <li className="page-item">
                            <Link
                                className="page-link bg-neutral-200 text-secondary-light fw-semibold radius-8 border-0 d-flex align-items-center justify-content-center h-32-px w-32-px text-md"
                                to="#"
                            >
                                3
                            </Link>
                        </li>
                        <li className="page-item">
                            <Link
                                className="page-link bg-neutral-200 text-secondary-light fw-semibold radius-8 border-0 d-flex align-items-center justify-content-center h-32-px w-32-px text-md"
                                to="#"
                            >
                                4
                            </Link>
                        </li>
                        <li className="page-item">
                            <Link
                                className="page-link bg-neutral-200 text-secondary-light fw-semibold radius-8 border-0 d-flex align-items-center justify-content-center h-32-px w-32-px text-md"
                                to="#"
                            >
                                5
                            </Link>
                        </li>
                        <li className="page-item">
                            <Link
                                className="page-link bg-neutral-200 text-secondary-light fw-semibold radius-8 border-0 d-flex align-items-center justify-content-center h-32-px text-md"
                                to="#"
                            >
                                {" "}
                                <Icon icon="ep:d-arrow-right" className="" />{" "}
                            </Link>
                        </li>
                    </ul>
                </div> */}

            {filteredData?.length > itemsPerPage && (
              <div className="d-flex flex-wrap align-items-center justify-content-between gap-2 mt-24">
                <span>
                  Showing {startIdx + 1} to{" "}
                  {Math.min(startIdx + itemsPerPage, filteredData?.length)} of{" "}
                  {filteredData?.length} entries
                </span>
                <ul className="pagination d-flex flex-wrap align-items-center gap-2 justify-content-center">
                  <li className="page-item">
                    <button
                      className="page-link text-secondary-light fw-medium radius-4 border-0 px-10 py-10 d-flex align-items-center justify-content-center h-32-px me-8 w-32-px bg-base"
                      onClick={() => goToPage(currentPage - 1)}
                      disabled={currentPage === 1}
                    >
                      <Icon icon="ep:d-arrow-left" className="text-xl" />
                    </button>
                  </li>

                  {[...Array(totalPages)].map((_, index) => (
                    <li className="page-item" key={index}>
                      <button
                        className={`page-link ${
                          currentPage === index + 1
                            ? "bg-primary-600 text-white"
                            : "bg-primary-50 text-secondary-light"
                        } fw-medium radius-4 border-0 px-10 py-10 d-flex align-items-center justify-content-center h-32-px me-8 w-32-px`}
                        onClick={() => goToPage(index + 1)}
                      >
                        {index + 1}
                      </button>
                    </li>
                  ))}

                  <li className="page-item">
                    <button
                      className="page-link text-secondary-light fw-medium radius-4 border-0 px-10 py-10 d-flex align-items-center justify-content-center h-32-px me-8 w-32-px bg-base"
                      onClick={() => goToPage(currentPage + 1)}
                      disabled={currentPage === totalPages}
                    >
                      <Icon icon="ep:d-arrow-right" className="text-xl" />
                    </button>
                  </li>
                </ul>
              </div>
            )}
          </div>
        </div>

        <div
          className="modal fade"
          id="exampleModalEdit"
          tabIndex={-1}
          aria-labelledby="exampleModalEditLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content radius-16 bg-base">
              <div className="modal-header py-16 px-24 border border-top-0 border-start-0 border-end-0">
                <h1 className="modal-title fs-5" id="exampleModalEditLabel">
                  Confirm Deletion
                </h1>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                />
              </div>
              <div className="modal-body p-24 text-center">
                <p className="mb-4 fs-6 text-secondary">
                  Are you sure you want to delete this item?
                </p>
                <div className="d-flex justify-content-center gap-3 mt-3">
                  <button
                    type="button"
                    className="btn btn-danger"
                    onClick={handleConfirmDelete}
                  >
                    Confirm
                  </button>
                  <button
                    type="button"
                    className="btn btn-secondary"
                    data-bs-dismiss="modal"
                  >
                    Cancel
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    );
};

export default PackageV2;